import { PaymentDto } from '@core/mappers/user/pushNotifications/dtos/PaymentDto';
import Payment from '@core/models/user/pushNotifications/Payment';

export function transformPayment(obj: PaymentDto): Payment {
    return {
        clientRequestId: obj.PaymentResult.client_request_id,
        paymentId: obj.PaymentResult.client_request_id,
        status: obj.PaymentResult.status,
        paymentProvider: obj.PaymentResult.payment_provider,
    };
}
